import * as $ from 'jquery';
import 'slick-carousel';

export function HistorySliderController() {

    function HistorySlider() {
        let historySliderSelector = '.js-historySlider';
        let navigationSelector = '.js-historySliderNavigation';
        let navigationElementSelector = '.historySlider__navigationItem';
        let navigationElementActiveClass = 'historySlider__navigationItem--active';
        let navigationElementLeftClass = 'historySlider__navigationItem--left';
        let navigationElementModifierClass = 'historySlider__navigationItem--';
        let navigationActiveYearClass = 'historySlider__navigationListYearWrapper--active';
        let navigationMarkerMainClass = 'historySlider__navigationItem--main';
        let navigationMarkerSubClass = 'historySlider__navigationItem--sub';
        let yearWrapperClass = 'historySlider__navigationListYearWrapper';
        let yearWrapperLabelClass = 'historySlider__navigationListYearLabel';
        let activeYear = 0;
        const allYears: any[] = [];
        let maxVisibleSubElements = 5;

        /**
         * Public function to init class
         */
        function mainInit() {
            const $historySlider = $(historySliderSelector);

            if ($historySlider.length) {
                initHistorySlider($historySlider);
            }
        }

        /**
         * initHistorySlider
         */
        const initHistorySlider = function ($historySlider) {
            const $sliderNavigation = $(navigationSelector);

            $historySlider.on('init', function () {
            initNavigation($(this), $sliderNavigation);
            });

            $historySlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: false,
            asNavFor: '.historySlider__navigationList',
            autoplay: false,
            });
        };

        /**
         * init HistorySlider navigation, rearrange markup
         */
        const initNavigation = function ($historySlider, $sliderNavigation) {
            const $navigationButtons = $sliderNavigation.find('.js-navigationButton');
            let lastYear = 0;

            const $historyNavigationList = $('.historySlider__navigationList');

            $navigationButtons.each(function () {
                const $button = $(this);
                const currentYear = $button.data('year');
                if (lastYear < currentYear) {
                    lastYear = currentYear;
                    allYears.push(currentYear);
                    $button.addClass(navigationMarkerMainClass);
                } else if (currentYear === lastYear) {
                    $button.addClass(navigationMarkerSubClass);
                }
            });

            for (let i = 0; i < allYears.length; i++) {
                const $yearGroup = $navigationButtons.parent().find('*[data-year="' + allYears[i] + '"]');
                $yearGroup.wrapAll('<span class="' + yearWrapperClass + '"></span>');
                $yearGroup.parent().append('<span class="' + yearWrapperLabelClass + '">' + allYears[i] + '</span>');
            }

            $historySlider.on('beforeChange', function (event, slickSlider, currentSlide, nextSlide) {
                const $thisButton = $navigationButtons.eq(nextSlide);
                activateMenuItem($historySlider, $navigationButtons, $thisButton, nextSlide, $historyNavigationList);
            });

            // activate first navigation item
            $navigationButtons.first().addClass(navigationElementActiveClass).parent().addClass(navigationActiveYearClass);

            $historyNavigationList.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                    s: false,
                infinite: false,
                autoplay: false,
                asNavFor: historySliderSelector,
                centerPadding: '0',
                centerMode: true,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                ],
            });

            $historyNavigationList.on('breakpoint', function () {
                addNavigationButtonClickListener($historySlider, $historyNavigationList, $navigationButtons);
            });

            addNavigationButtonClickListener($historySlider, $historyNavigationList, $navigationButtons);
        };

        const addNavigationButtonClickListener = function ($historySlider, $historyNavigationList, $navigationButtons) {
            $navigationButtons.each(function () {
                const $button = $(this);

                $button.on('click', function () {
                    const id = $button.data('relatedslide');
                    activateMenuItem($historySlider, $navigationButtons, $(this), id, $historyNavigationList);
                });
            });
        };

        const activateMenuItem = function ($historySlider, $navigationButtons, $button, mainSliderId, $historyNavigationList) {
            $historySlider.slick('slickGoTo', parseInt(mainSliderId, 10));
            $navigationButtons.removeClass(navigationElementActiveClass);
            $button.addClass(navigationElementActiveClass);
            const switchYear = ($button.data('year') !== activeYear);
            activeYear = $button.data('year');
            showDetailsOfYear($navigationButtons, $button, switchYear, $historyNavigationList);
        };

        const showDetailsOfYear = function ($navigationButtons, $button, switchYear, $historyNavigationList) {
            const $currentYearWrapper = $button.closest('.' + yearWrapperClass);
            let query = navigationElementLeftClass;

            // remove all classes for height reset
            for (let i = 1; i <= maxVisibleSubElements; i++) {
                $navigationButtons.removeClass(navigationElementModifierClass + i);
                query = query + ' ' + navigationElementModifierClass + i;
            }
            $navigationButtons.removeClass(query);

            if (switchYear) {
                $navigationButtons.parent().removeClass(navigationActiveYearClass);
                $currentYearWrapper.addClass(navigationActiveYearClass);
                const navigationId = $button.closest('.slick-slide').data('slick-index');
                $historyNavigationList.slick('slickGoTo', parseInt(navigationId, 10));
            }
            recursiveChangeItemHeight($button, true, 1);
            recursiveChangeItemHeight($button, false, 1);
        };

        const recursiveChangeItemHeight = function ($button, forwards, index) {
            let $nextButton = null;
            if (forwards) {
                $nextButton = $button.next(navigationElementSelector);
            } else {
                $nextButton = $button.prev(navigationElementSelector);
            }
            // @ts-ignore: Object is possibly 'null'.
            if ($nextButton.length > 0) {
                let newIndex = (index < maxVisibleSubElements) ? index : maxVisibleSubElements;
                $($nextButton!).addClass(navigationElementModifierClass + newIndex);
                if (!forwards) {
                    $($nextButton!).addClass(navigationElementLeftClass);
                }
                recursiveChangeItemHeight($nextButton, forwards, index + 1);
            }
        };
        mainInit();
    }
    HistorySlider();
}
